import styled from 'styled-components';

export const FormItemArea = styled.div`
	.radio-column-without-label {
		.ant-space {
			flex-direction: column;
			align-items: flex-start;
		}
	}
`;
